import React, { Component } from 'react'
import '../styles/ActivityDetailsView.css'
import xButton from '../images/x-white.png'
import Overlay from '../widgets/Overlay'
import OverlayForm from '../widgets/OverlayForm'
import APICalendarRequest from '../api/APICalendarRequest'
import APICalendar from '../api/APICalendar'

class ActivityDetails extends Component
{
	constructor(props) {
		super(props)
		this.state = {
			accessToken: JSON.parse(sessionStorage.getItem("token")),
			show: false
		}
		this.getActivityById = this.getActivityById.bind(this)
	}

	getActivityById(id) {
		const types = APICalendarRequest.getActivityById(this.state.accessToken, id);
		types.then((response) => {
			if(response.status === "FAILED") {
				return;
			}
			if(response.status === "ERROR") {
				return;
			}
			const resourcePersons = []
			if(response.results.resourcePerson != null) {
				for(const v of response.results.resourcePerson) {
					const name = v.last_name + ", " + v.first_name
					resourcePersons.push(<div>{name.toUpperCase()}</div>)
				}
			}
			const facilitators = []
			if(response.results.facilitator != null) {
				for(const v of response.results.facilitator) {
					const name = v.last_name + ", " + v.first_name
					facilitators.push(<div>{name.toUpperCase()}</div>)
				}
			}
			this.setState({
				data: response.results,
				resourcePersons: resourcePersons,
				facilitators: facilitators
			});
		});
	}

	componentDidUpdate(prevProps) {
		if(prevProps.show != this.props.show) {
			this.getActivityById(this.props.data.activity_id)
			let bc
			const status = checkStatus(this.props.dateString, this.props.data.activity_status_id)
			switch(status) {
				case 1: // current month
					bc = "#ffffff"
					break
				case 2: //"attention":
					bc = "#c96f6f"
					var bg = "#9d9d9d"
					break
				case 3: // done
					bc = "#9d9d9d"
					bg = "#9d9d9d"
					break
				case 4: //"happening":
					bc = "#a9be3d"
					break
				case 5: //"upcoming":
					bc = "#ddbc33"
					break
				default:
					bc = "#f4f4f4"
			}
			this.setState({
				bgColor: bc,
				btnColor: bc,
				show: this.props.show,
				btnGray: bg,
				cHeight: (this.props.show)? "100%": "0%",
				status: status
			});
		}
	}

	render() {
		let btnText = "UPDATE"
		if(this.state.status == 2 || this.state.status == 3) {
			btnText = "ENCODE ATTENDANCE"
		}
		const c = <div id="activity-details">
			{this.state.show && <div id={"act-details-header"} style={{background: this.state.bgColor}}>
				<div id="act-details-title">ACTIVITY DETAILS</div>
				<div id="act-details-close">
					<img src={xButton} id="x-button" alt="Close" onClick={() => {
						this.props.hide()
					}} />
				</div>
			</div>}
			{(this.state.show && this.state.data != null) && <div id={"act-details-content"}>
				<p>
					<div>Activity:</div>
					<div>{this.state.data.activity.activity_title.toUpperCase()}</div>
				</p>
				<p>
					<div>Date From:</div>
					<div>{formatDate(this.state.data.activity.start_date)}</div>
				</p>
				<p>
					<div>Date To:</div>
					<div>{formatDate(this.state.data.activity.end_date)}</div>
				</p>
				<p>
					<div>Time:</div>
					<div>{this.state.data.activity.start_time} - {this.state.data.activity.end_time}</div>
				</p>
				<p>
					<div>Location:</div>
					<div>{this.state.data.activity.venue.toUpperCase()}, {this.state.data.activity.barangay.toUpperCase()}, {this.state.data.activity.city.toUpperCase()}
					</div>
				</p>
				<p>
					<div>Resource Person(s):</div>
					<div>{this.state.resourcePersons}</div>
				</p>
				<p>
					<div>Facilitator(s):</div>
					<div>{this.state.facilitators}</div>
				</p>
				<p>
					<div>Audience:</div>
					<div>{this.state.data.activity.participant_type.toUpperCase()}</div>
				</p>
				<p>
					{(this.state.status == 2 || this.state.status == 3) && <button className="activity-details-button"
						style={{"background-color": this.state.btnGray}}
						onMouseEnter={() => { this.setState({btnGray: "#9d9d9d60"}) }}
						onMouseDown={() => { this.setState({btnGray: "#9d9d9dA0"}) }}
						onMouseLeave={() => { this.setState({btnGray: "#9d9d9d"}) }}
						onClick={(e) => {
							this.props.onSignal("update-activity", this.state.data.activity.activity_id, this.state.status)
						}}>UPDATE</button>}
					<button className="activity-details-button"
						style={{"background-color": this.state.btnColor}}
						onMouseEnter={() => { this.setState({btnColor: this.state.bgColor + "60"}) }}
						onMouseDown={() => { this.setState({btnColor: this.state.bgColor + "A0"}) }}
						onMouseLeave={() => { this.setState({btnColor: this.state.bgColor}) }}
						onClick={(e) => {
							let v = "update-activity"
							if(this.state.status == 2 || this.state.status == 3) {
								v = "encode-attendance"
							}
							this.props.onSignal(v, this.state.data.activity.activity_id, this.state.status)
						}}>{btnText}</button>
				</p>
			</div>}
		</div>
		return(<div className="activity-details">
			<OverlayForm content={c} cHeight={this.state.cHeight} top='200px' left='50%' />
		</div>)
	}
}

const checkStatus = (date, statId) => {
	const d = new Date()
	const pd = Date.parse(d.toDateString())
	const pDate = Date.parse(date)
	let status
	if(pDate < pd) {
		status = 3 // "done"
		if(statId === 1) {
			status = 2 // "attention"
		}
	}
	else if(pDate > pd) {
		status = 5 // "upcoming"
	}
	else if(pDate == pd) {
		status = 4 // "happening"
	}
	return(status)
}

const formatDate = (dt) => {
	const date = new Date(dt)
	const day = APICalendar.getDayString(date.getDay())
	const month = APICalendar.getMonthString(date.getMonth())
	const v = day + ", " + month + " " + date.getDate() + ", " + date.getFullYear()
	return(v)
}

export default ActivityDetails
